var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldDriving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18v-1c0-.41.34-.75.75-.75s.75.34.75.75v1c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM11.25 22v-1c0-.41.34-.75.75-.75s.75.34.75.75v1c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM1.818 22.728c-.4-.1-.65-.51-.55-.91l1-4a.75.75 0 1 1 1.46.36l-1 4c-.09.34-.39.57-.73.57-.06 0-.12-.01-.18-.02zM21.023 21.933l-1-4c-.1-.4.14-.81.55-.91.4-.1.81.14.91.55l1 4c.1.4-.14.81-.55.91a.757.757 0 0 1-.91-.55zM18.598 5.84H5.528c-.3 0-.54-.25-.54-.54 0-.3.25-.54.54-.54h.74l.28-1.31c.26-1.28.8-2.45 2.96-2.45h5.09c2.16 0 2.71 1.17 2.97 2.44l.28 1.31h.74c.3 0 .55.25.55.55 0 .3-.25.54-.54.54z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.688 6.93h-9.26c-2.33 0-2.64 1.28-2.76 2.47l-.41 4.42c-.05.55.13 1.1.51 1.52.39.42.93.66 1.51.66h1.36c1.18 0 1.4-.67 1.55-1.12l.15-.44c.17-.5.21-.62.86-.62h3.72c.65 0 .67.07.86.62l.15.44c.14.45.37 1.12 1.54 1.12h1.36c.57 0 1.12-.24 1.51-.66.38-.41.56-.97.51-1.52l-.4-4.42c-.11-1.2-.43-2.47-2.76-2.47zm-8.98 3.99c-.3 0-.54-.25-.54-.54 0-.29.25-.54.54-.54h2.18c.3 0 .54.25.54.54 0 .29-.25.54-.55.54h-2.17zm6.52 0c-.3 0-.54-.25-.54-.54 0-.29.25-.54.54-.54h2.18c.3 0 .54.25.54.54 0 .29-.24.54-.54.54h-2.18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldDriving);
export default __webpack_public_path__ + "static/media/vuesax-bold-driving.e154050496505d2e449b53433911b571.svg";
export { ForwardRef as ReactComponent };